

























































































































































































import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { ValidationObserver } from 'vee-validate';
import { truncate } from 'lodash';
import {
  serviceTypeOptions,
  ServiceFormStatusOption,
  serviceFormStatusOptions,
  serviceTimeOptions,
  ServiceTypes,
} from '@/configs/service-form';
import { getFormList, getFormDetail, putFormDetail } from '@/configs/api-path';
import VuetableMixin from '@/mixins/vuetable';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import DatatableHeading from '@/components/piaf/Datatable/DatatableHeading.vue';
import VuetablePaginationBootstrap from '@/components/piaf/Common/VuetablePaginationBootstrap.vue';
import GlideComponent from '@/components/piaf/Carousel/GlideComponent.vue';
import { ServiceFormListItem, ServiceFormDetail } from '@/models/service';
import { ProjectMenu } from '@/models/project';
import { VuetableSortOrder, VuetablePagination } from '@/@types/vuetable.d';
import { getFileName } from '@/utils/file';

@Component({
  components: {
    DatatableHeading,
    VuetablePaginationBootstrap,
    GlideComponent,
  },
})
export default class PageFormList extends mixins(VuetableMixin, ApiStatusMixin, ApiErrorMixin) {
  $refs!: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    vuetable: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pagination: any;
    editServiceFormObs: InstanceType<typeof ValidationObserver>;
  };

  serviceFormStatusOptions: ServiceFormStatusOption[] = serviceFormStatusOptions;

  tablePrepage = 10;

  serviceFormList: ServiceFormListItem[] = [];

  serviceFormDetail: ServiceFormDetail | null = null;

  slideOptions = {
    perView: 1,
  }

  dataTableFields = [
    {
      name: 'id',
      title: '表單編號',
      width: '110px',
      titleClass: 'text-center',
      dataClass: 'text-center',
      sortField: 'id',
    },
    {
      name: 'name',
      title: '客戶姓名',
      sortField: 'name',
    },
    {
      // TODO: _.truncate value
      name: 'content',
      title: '內容說明',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      formatter(value: any) {
        return truncate(value, {
          length: 16,
        });
      },
    },
    {
      name: 'created_at',
      title: '建立日期',
      sortField: 'created_at',
      width: '130px',
    },
    {
      name: 'updated_at',
      title: '更新日期',
      sortField: 'updated_at',
      width: '130px',
    },
    {
      name: 'status--slot',
      title: '狀態',
      width: '110px',
      titleClass: 'text-center',
      dataClass: 'text-center',
      sortField: 'status',
    },
    {
      name: 'action--slot',
      title: '操作',
      width: '186px',
      titleClass: 'text-center',
      dataClass: 'text-center',
    },
  ];

  get currentServiceType() {
    return this.$route.params.serviceType;
  }

  get currentServiceTypeDetail() {
    return serviceTypeOptions.find((service) => service.slug === this.currentServiceType);
  }

  // TODO: search fields
  get filtedServiceFormList() {
    return this.serviceFormList.filter((serviceForm) => {
      const matchRegexp = new RegExp(
        this.filterKeyword === '' ? '.*' : `.*(${this.filterKeyword}).*`,
        'gi',
      );

      const matchName = serviceForm.name.match(matchRegexp);
      const matchContent = serviceForm.content.match(matchRegexp);

      return Boolean(matchName)
        || Boolean(matchContent);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  get isServiceFormHasPhotos() {
    return this.serviceFormDetail ? this.serviceFormDetail.album.length > 0 : false;
  }

  get serviceFormSession() {
    return this.serviceFormDetail ? serviceTimeOptions
      .find((session) => session.value === this.serviceFormDetail?.session) : null;
  }

  get serviceFormProject() {
    return this.serviceFormDetail && this.serviceFormDetail.projectId
      ? this.menuProjects.find((project) => project.id === this.serviceFormDetail?.projectId)
      : null;
  }

  get pageDescription() {
    // eslint-disable-next-line no-nested-ternary
    return this.currentServiceTypeDetail
      ? this.currentServiceType === ServiceTypes.OTHER
        ? '管理其他的表單內容。'
        : `管理興${this.currentServiceTypeDetail.label}相關的表單內容。`
      : '管理表單內容。';
  }

  get breadcrumb() {
    return [
      {
        text: '表單管理',
        to: null,
      },
      {
        text: this.currentServiceTypeDetail?.label,
        to: null,
      },
      // {
      //   text: '表單列表',
      //   to: null,
      // },
    ];
  }

  @Getter('app/getMenuProjectsAll') menuProjects!: ProjectMenu[];

  @Watch('filtedServiceFormList')
  onFiltedServiceFormChange() {
    this.$refs.vuetable.refresh();
  }

  @Watch('tablePrepage')
  onTablePrepageChange() {
    if (this.vuetablePrepage !== undefined) {
      this.vuetablePrepage = this.tablePrepage;
    }
    this.$refs.vuetable.refresh();
  }

  // eslint-disable-next-line class-methods-use-this
  getFilename(path: string) {
    return getFileName(path);
  }

  // eslint-disable-next-line class-methods-use-this
  async openServiceFormModal(formId: number) {
    if (!formId) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: formDetailResponse } = await this.$axios.get<{
        code: number;
        form: ServiceFormDetail;
      }>(getFormDetail(formId));

      if (formDetailResponse.code === 0) {
        this.serviceFormDetail = formDetailResponse.form;

        const currentItem = this.serviceFormList.find((form) => form.id === formId);
        if (currentItem) {
          currentItem.status = true;
        }
      }
      this.$root.$emit('bv::show::modal', 'viewServiceForm');
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  // eslint-disable-next-line class-methods-use-this
  onViewServiceFormModalShow() {
    // this.resetServiceFormForm();
  }

  onViewServiceFormModalHide() {
    this.resetServiceForm();
  }

  hideModal(refname: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const vmRefs = this.$refs as any;

    if (!vmRefs[refname]) {
      return;
    }

    vmRefs[refname].hide();

    if (refname === 'modalnestedinline') {
      vmRefs.modalnested.show();
    }
  }

  changePageSize(size: number) {
    this.tablePrepage = size;
  }

  onPaginationData(paginationData: VuetablePagination) {
    this.$refs.pagination.setPaginationData(paginationData);
  }

  onChangePage(page: number) {
    this.$refs.vuetable.changePage(page);
  }

  resetServiceForm() {
    if (this.$refs.editServiceFormObs) {
      this.$refs.editServiceFormObs.reset();
    }
    this.serviceFormDetail = null;
  }

  dataManager(sortOrder: VuetableSortOrder[], pagination: VuetablePagination) {
    const tableData = this.vuetableDataManager(
      this.sortMode ? [{
        direction: 'asc',
        field: 'sort',
        sortField: 'sort',
      }] : sortOrder,
      pagination,
      this.$refs.vuetable,
      this.filtedServiceFormList,
    );
    this.tablePagination = tableData.pagination;
    return tableData;
  }

  async updateServiceFormSubmit(modalName: string) {
    if (!this.serviceFormDetail) {
      return;
    }

    this.setApiLoading();

    try {
      const validateResult = await this.$refs.editServiceFormObs.validate();

      if (validateResult === false) {
        this.setApiPending();
        return;
      }

      const { data: formResponse } = await this.$axios
        .put<{
          code: number;
          form: {
            id: number;
          };
        }>(putFormDetail(this.serviceFormDetail.id as string), {
          note: this.serviceFormDetail.note,
        });
      this.setApiPending();

      if (formResponse.code === 0) {
        this.$notify.show('success filled', '表單已成功更新！', '表單管理');

        this.hideModal(modalName);

        this.fetchServiceForm();
      } else {
        this.apiErrorCodeAlert(formResponse.code, '表單管理');
      }
    } catch (error) {
      console.error(error);
      this.setApiPending();
    }
  }

  async fetchServiceForm() {
    if (!this.currentServiceTypeDetail) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: formResponse } = await this.$axios.get<{
        code: number;
        form: ServiceFormListItem[];
      }>(getFormList(this.currentServiceTypeDetail.code));

      if (formResponse.code === 0) {
        this.serviceFormList = formResponse.form;
      } else {
        this.apiErrorCodeAlert(formResponse.code, `表單管理 - ${this.currentServiceTypeDetail.label}`);
      }
    } catch (error) {
      this.apiHttpErrorAlert(error.response, `表單管理 - ${this.currentServiceTypeDetail.label}`);
      console.error(error);
    }
    this.setApiPending();
  }

  beforeMount() {
    if (this.currentServiceTypeDetail) {
      this.fetchServiceForm();
    }
  }
}
